export default {
  arrrowLinkFill: Styles.color.grey.one,
  arrowLinkLabelColor: Styles.color.grey.one,
};
